import { supabase } from "@/integrations/supabase/client";

export async function callProfileBuilder(body: Record<string, unknown>) {
  const { data, error } = await supabase.functions.invoke("company-profile-builder", { body });
  if (error) {
    let msg = error.message;
    try { const ctx = await (error as any).context?.json?.(); if (ctx?.error) msg = ctx.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

type Base = { workspaceId: string | null; guestToken: string | null; profileId: string };
const TTL = 5 * 60 * 1000;
const cache = new Map<string, { at: number; p: Promise<any> }>();

/** Cached "get" of a business profile; shared by the business and strategy dialogs. */
export function getProfileCached(base: Base, fresh = false) {
  const key = `${base.guestToken ?? base.workspaceId}:${base.profileId}`;
  const hit = cache.get(key);
  if (!fresh && hit && Date.now() - hit.at < TTL) return hit.p;
  const p = callProfileBuilder({ ...base, action: "get" });
  p.catch(() => cache.delete(key));
  cache.set(key, { at: Date.now(), p });
  return p;
}

export function forgetProfile(profileId: string) {
  for (const k of cache.keys()) if (k.endsWith(`:${profileId}`)) cache.delete(k);
}

let warmedAt = 0;
/** Wake the AI builder functions so the first real call doesn't wait for a cold start. */
export function warmProfileBuilder() {
  if (Date.now() - warmedAt < 4 * 60 * 1000) return;
  warmedAt = Date.now();
  for (const fn of ["company-profile-builder", "ai-knowledge-assistant"]) {
    supabase.functions.invoke(fn, { body: { action: "ping" } }).catch(() => { /* warm-up only */ });
  }
}
